import { Stack, Anchor } from "@mantine/core"
import { QRCodeCanvas } from "qrcode.react"
import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"
import { useTranslation } from "react-i18next"

interface Props {
  userAuthenticationFactorId: number
}

export function AuthenticatorAppStack({ userAuthenticationFactorId }: Props) {
  const { data: uri } = useSuspenseQueryGet(
    "/api/UserAuthenticationFactor/GetAuthenticatorAppUri",
    { userAuthenticationFactorId }
  )
  const { t } = useTranslation("app_server")

  return (
    <Stack align="center">
      <QRCodeCanvas
        value={uri}
        size={200}
        bgColor="#ffffff"
        fgColor="#000000"
        level="Q"
      />
      <Anchor ta={"center"} href={uri}>
        {t("UserAuthenticationFactor_AuthenticatorAppInstructions")}
      </Anchor>
    </Stack>
  )
}
